export const makeTooltipId = (title: string) => title?.replace(/[^a-zA-Z0-9-_]/g, '_') ?? '';
